import React from 'react';

const members = [
  { name: 'Όνομα Καλλιτέχνη', role: 'Σκηνοθέτης', image: 'https://images.unsplash.com/photo-1509783236416-c9ad59bae472?w=400&q=80' },
  { name: 'Όνομα Καλλιτέχνη', role: 'Ηθοποιός', image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&q=80' },
  { name: 'Όνομα Καλλιτέχνη', role: 'Χορογράφος', image: 'https://images.unsplash.com/photo-1504257432389-52343af06ae3?w=400&q=80' },
  { name: 'Όνομα Καλλιτέχνη', role: 'Μουσικός', image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80' },
  { name: 'Όνομα Καλλιτέχνη', role: 'Σκηνογράφος', image: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400&q=80' },
  { name: 'Όνομα Καλλιτέχνη', role: 'Ηθοποιός', image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80' },
];

export default function Team() {
  return (
    <section style={{ padding: '120px 64px', maxWidth: '1200px', margin: '0 auto' }}>
      <PageHeader title="Η Ομάδα" subtitle="Οι Καλλιτέχνες" />

      <p style={{
        fontFamily: 'var(--font-display)',
        fontSize: '1.2rem',
        fontWeight: 400,
        lineHeight: 1.8,
        letterSpacing: '0.02em',
        color: 'var(--dark-gray)',
        maxWidth: '700px',
        marginBottom: '72px',
        fontStyle: 'italic',
      }}>
        Ένα δίκτυο καταξιωμένων καλλιτεχνών που πιστεύουν στη δύναμη της συλλογικής δημιουργίας.
      </p>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: '2px',
      }}>
        {members.map((member, i) => (
          <MemberCard key={i} member={member} />
        ))}
      </div>
    </section>
  );
}

function MemberCard({ member }) {
  const [hovered, setHovered] = React.useState(false);

  return (
    <div
      style={{ position: 'relative', overflow: 'hidden', aspectRatio: '3/4', cursor: 'pointer' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <img
        src={member.image}
        alt={member.name}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          filter: hovered ? 'brightness(0.5)' : 'brightness(0.85) grayscale(30%)',
          transition: 'all 0.5s ease',
          transform: hovered ? 'scale(1.04)' : 'scale(1)',
        }}
      />
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        padding: '24px',
        background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
        transform: hovered ? 'translateY(0)' : 'translateY(8px)',
        transition: 'transform 0.4s ease',
      }}>
        <p style={{
          fontFamily: 'var(--font-display)',
          fontSize: '1.3rem',
          fontWeight: 400,
          color: 'white',
          letterSpacing: '0.05em',
        }}>{member.name}</p>
        <p style={{
          fontSize: '0.65rem',
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
          color: 'var(--accent)',
          marginTop: '4px',
        }}>{member.role}</p>
      </div>
    </div>
  );
}

function PageHeader({ title, subtitle }) {
  return (
    <div style={{ marginBottom: '48px' }}>
      <p style={{
        fontSize: '0.62rem',
        letterSpacing: '0.2em',
        textTransform: 'uppercase',
        color: 'var(--accent)',
        marginBottom: '12px',
      }}>{subtitle}</p>
      <h1 style={{
        fontFamily: 'var(--font-display)',
        fontSize: 'clamp(2.5rem, 6vw, 5rem)',
        fontWeight: 300,
        letterSpacing: '0.04em',
        color: 'var(--black)',
        lineHeight: 1,
      }}>{title}</h1>
      <div style={{ width: '40px', height: '1px', background: 'var(--accent)', marginTop: '20px' }} />
    </div>
  );
}
